import { FormikProps, useFormik } from 'formik';
import React from 'react';
import { Button, Dialog, Grid } from 'src/components';
import DialogActions from 'src/components/DialogActions';
import DialogContent from 'src/components/DialogContent';
import DialogTitle from 'src/components/DialogTitle';
import NumberField from 'src/components/NumberField';
import { translate } from 'src/i18n/tHelper';
import VwKurumbonustanimdetayDTO from 'src/models/KurumBonusTanim/VwKurumbonustanimdetayDTO';
import IslemlerAutocomplete from 'src/parts/Hizmet/IslemlerAutocomplete';
import KurumBonusIslemlerAutoComplete from 'src/parts/KurumBonusTanimlari/KurumBonusIslemlerAutocomplete';
import { useKurumBonusTanimDetayEkleMutation, useKurumBonusTanimDetayGuncelleMutation } from 'src/services/KurumBonusTanimlari/KurumBonusTanimlariApi';
import { useAppDispatch, useAppSelector } from 'src/store';
import { kurumBonusTanimlariTestBazliSlice } from 'src/store/Slices/KurumBonusTanimlari/KurumBonusTanimlariTestBazliSlice';
import * as yup from 'yup';

const translatePath = "pages|kurumBonusTanimlari";
let formik: FormikProps<VwKurumbonustanimdetayDTO> = null;
const KurumBonusTanimlariTestBazliEkle = (): JSX.Element => {
    const state = useAppSelector(s => s.kurumBonusTanimlariTestBazli);
    const dispatch = useAppDispatch();

    const [ekle, ekleState] = useKurumBonusTanimDetayEkleMutation();
    const [guncelle, guncelleState] = useKurumBonusTanimDetayGuncelleMutation();

    const handlerSave = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if (!ekleState.isLoading && !guncelleState.isLoading)
            formik.submitForm();
    }
    const handlerClose = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        dispatch(kurumBonusTanimlariTestBazliSlice.actions.setOpen(false));
    };

    formik = useFormik({
        enableReinitialize: true,
        initialValues: state.activeRow,
        validateOnChange: false,
        onSubmit: async (values) => {
            if (values?.id > 0) {
                await guncelle(values).unwrap().then(() => { handlerClose(null); }).catch(e => e);
                return;
            }
            await ekle(values).unwrap().then(() => { handlerClose(null); }).catch(e => e);
        },
        validationSchema: yup.object().shape({
            fkIslemtanimId: yup.number().required(translate(translatePath, "Kurum alanı zorunludur.")),
            oran: yup.number().required(translate(translatePath, "Oran alanı zorunludur.")).typeError(translate(translatePath, "Oran alanı zorunludur.")),
        }),
    });

    return (
        <Dialog fullWidth open={state.open} maxWidth="sm">
            <DialogTitle>{translate(translatePath, "Kurum Bonus Tanımı Ekle")}</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item>
                        <KurumBonusIslemlerAutoComplete
                            required
                            label={translate(translatePath, "İşlem")}
                            placeholder={translate(translatePath, "Arama yapmak için en az 3 karakter giriniz")}
                            name="fkIslemtanimId"
                            value={formik.values.fkIslemtanimId}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.fkIslemtanimId)}
                            helperText={formik.errors.fkIslemtanimId}
                        />
                    </Grid>
                    <Grid item sm={6}>
                        <NumberField
                            required
                            allowNegative={false}
                            decimalScale={2}
                            label={translate(translatePath, "Oran")}
                            name="oran"
                            value={formik.values.oran}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.oran)}
                            helperText={formik.errors.oran}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disabled={!formik.dirty} loading={ekleState.isLoading || guncelleState.isLoading} customType="save" onClick={handlerSave} />
                <Button customType="close" onClick={handlerClose} />
            </DialogActions>
        </Dialog>
    );
};

export default KurumBonusTanimlariTestBazliEkle;